const DragonStatus = Object.freeze({
  REJECTED: 0,
  REJECTED_FOR_SHELL_COMPANY: 1,
  REJECTED_FOR_PLD: 2,
  PENDING: 10,
  APPROVED: 20,
  DISABLED: 30
})

module.exports = DragonStatus
